export var TermType;
(function (TermType) {
    TermType["NamedNode"] = "NamedNode";
    TermType["BlankNode"] = "BlankNode";
    TermType["Literal"] = "Literal";
})(TermType || (TermType = {}));
export var QuadPosition;
(function (QuadPosition) {
    QuadPosition[QuadPosition["subject"] = 0] = "subject";
    QuadPosition[QuadPosition["predicate"] = 1] = "predicate";
    QuadPosition[QuadPosition["object"] = 2] = "object";
    QuadPosition[QuadPosition["graph"] = 3] = "graph";
})(QuadPosition || (QuadPosition = {}));
export var Feature;
(function (Feature) {
    /** Whether the factory supports termType:Collection terms */
    Feature["collections"] = "COLLECTIONS";
    /** Whether the factory supports termType:DefaultGraph terms */
    Feature["defaultGraphType"] = "DEFAULT_GRAPH_TYPE";
    /** Whether the factory supports equals on produced instances */
    Feature["equalsMethod"] = "EQUALS_METHOD";
    /**
     * Whether the factory is an {IdentityFactory}, so it allows reverse lookups to be done with
     * {fromId}.
     */
    Feature["identity"] = "IDENTITY";
    /** Whether the factory supports mapping ids back to instances */
    Feature["nodeLookup"] = "NODE_LOOKUP";
    /** Whether the factory supports termType:Variable terms */
    Feature["variableType"] = "VARIABLE_TYPE";
})(Feature || (Feature = {}));
